const services = [
  {
    icon: 'ri-compass-3-line',
    title: 'Conseil d\'Orientation',
    description: 'Analyse approfondie de votre profil et recommandations personnalisées pour maximiser vos chances d\'obtention de visa.',
    features: [
      'Évaluation complète de votre dossier',
      'Identification du type de visa adapté',
      'Stratégie personnalisée',
      'Conseils d\'experts certifiés'
    ],
    color: 'from-teal-500 to-cyan-600',
    badge: 'Essentiel'
  },
  {
    icon: 'ri-quill-pen-line',
    title: 'Rédaction Professionnelle',
    description: 'Rédaction sur mesure de lettres d\'intention, d\'invitation, de prise en charge et justifications financières convaincantes.',
    features: ['Lettres personnalisées', 'Arguments solides', 'Style professionnel'],
    highlight: 'Arguments clairs et crédibles'
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Préparation à l\'Entretien Consulaire',
    description: 'Coaching personnalisé de 30 à 45 minutes avec simulation d\'entretien, questions fréquentes et techniques de réponses.',
    features: ['Mise en situation', 'Conseils comportementaux', 'Confiance assurée'],
    highlight: 'Abordez l\'entretien avec assurance'
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Réservations de Services',
    description: 'Réservations fiables d\'hôtel, vol et assurance voyage sans paiement immédiat pour renforcer votre dossier.',
    features: ['Hôtel', 'Vol', 'Assurance voyage'],
    highlight: 'Renforcez la crédibilité'
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Suivi du Dossier après Soumission',
    description: 'Accompagnement continu avec suivi régulier, mises à jour et assistance si des documents supplémentaires sont demandés.',
    features: ['Suivi en temps réel', 'Communication régulière', 'Support permanent'],
    highlight: 'Restez informé en permanence'
  },
  {
    icon: 'ri-refresh-line',
    title: 'Assistance Après Refus de Visa',
    description: 'Analyse du refus, explication claire et nouvelle stratégie pour transformer un refus en succès lors de la prochaine demande.',
    features: ['Analyse du refus', 'Corrections ciblées', 'Nouvelle stratégie'],
    highlight: 'Transformez un refus en succès'
  }
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-service-line text-teal-600"></i>
            <span className="text-teal-700 text-sm font-semibold">Nos Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Services d'Excellence pour Votre Réussite
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un accompagnement professionnel à chaque étape pour maximiser vos chances d'obtenir votre visa
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-teal-500/10 to-transparent rounded-bl-full transform translate-x-8 -translate-y-8 group-hover:scale-150 transition-transform duration-500"></div>
              
              <div className="relative">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-700 rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <div className="inline-flex items-center bg-teal-50 px-3 py-1 rounded-full mb-4">
                  <i className="ri-star-fill text-teal-600 text-sm mr-1"></i>
                  <span className="text-teal-700 text-xs font-semibold">{service.highlight}</span>
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-teal-600 mr-2 text-lg"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                <a 
                  href="#contact" 
                  className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors group/link cursor-pointer"
                >
                  <span>En savoir plus</span>
                  <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-800 rounded-3xl p-12 text-center text-white shadow-2xl relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
          
          <div className="relative">
            <div className="inline-flex items-center bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-customer-service-2-line text-white mr-2"></i>
              <span className="text-white text-sm font-semibold">Consultation Gratuite</span>
            </div>
            
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              Prêt à Réaliser Votre Projet de Voyage ?
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Contactez-nous dès maintenant pour une consultation personnalisée et découvrez comment nous pouvons vous accompagner vers le succès.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                href="#contact" 
                className="inline-flex items-center bg-white text-teal-600 px-8 py-4 rounded-full hover:bg-gray-100 transition-all font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line mr-2 text-xl"></i>
                Demander une Consultation
              </a>
              
              <a 
                href="https://wa.me/22892620409" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full hover:bg-white/20 transition-all font-semibold text-lg border-2 border-white/30 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                WhatsApp Direct
              </a>
            </div>
            
            <div className="mt-8 flex items-center justify-center space-x-8 text-white/80">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-2xl mr-2"></i>
                <span className="text-sm">98% de satisfaction</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-2xl mr-2"></i>
                <span className="text-sm">Réponse rapide</span>
              </div>
              <div className="flex items-center">
                <i className="ri-award-line text-2xl mr-2"></i>
                <span className="text-sm">Expertise reconnue</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
